import { render, staticRenderFns } from "./AcademyIndex.vue?vue&type=template&id=167abe12&scoped=true&"
import script from "./AcademyIndex.vue?vue&type=script&lang=js&"
export * from "./AcademyIndex.vue?vue&type=script&lang=js&"
import style0 from "./AcademyIndex.vue?vue&type=style&index=0&id=167abe12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167abe12",
  null
  
)

export default component.exports